import React, { useEffect, useCallback, useMemo } from "react";
import PortalSidebar from "components/PortalSidebar/PortalSidebar";
import { PortalHeader } from "components/PortalHeader";
import { connectPortalSocket, disconnectPortalSocket } from "services/portal/socket";
import { useSessionExpiry } from "hooks/useSessionExpiry";
import { SessionExpiryDialog } from "components/SessionExpiryDialog";

function logoutPortal({ expired = false } = {}) {
  try { localStorage.removeItem("userdata:portal"); } catch {}
  const suffix = expired ? "?expired=1" : "";
  window.location.replace(`/portal/login${suffix}`);
}

function decodeJwtPayload() {
  try {
    const data = JSON.parse(localStorage.getItem("userdata:portal") || "null");
    if (!data?.token) return null;
    const payload = data.token.split(".")[1];
    return JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
}

export function PortalDashboardLayout({ children }) {
  useEffect(() => {
    connectPortalSocket();
    return () => disconnectPortalSocket();
  }, []);

  const onAutoLogout = useCallback(() => logoutPortal({ expired: true }), []);
  const { warning, dismiss, expiryAt } = useSessionExpiry({ onLogout: onAutoLogout });

  const jwtPayload = useMemo(() => decodeJwtPayload(), []);
  const impersonatedBy = jwtPayload?.impersonatedBy;

  return (
    <>
      <PortalSidebar />
      <div
        style={{
          marginLeft: 220,
          minHeight: "100vh",
          background: "var(--bg-page)",
          color: "var(--text-primary)",
          transition: "background-color 200ms, color 200ms",
        }}
      >
        <PortalHeader onLogout={() => logoutPortal({ expired: false })} />
        {impersonatedBy && (
          <div
            style={{
              background: "#fef3c7",
              borderBottom: "1px solid #fcd34d",
              color: "#92400e",
              padding: "10px 32px",
              fontSize: 13,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            <span>
              <strong>Modo impersonación</strong> — Estás viendo el portal como cliente.
              Sesión iniciada por <strong>{impersonatedBy}</strong>.
            </span>
            <button
              onClick={() => logoutPortal({ expired: false })}
              style={{
                background: "transparent",
                border: "1px solid #92400e",
                color: "#92400e",
                padding: "4px 12px",
                borderRadius: 6,
                fontSize: 12,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Salir
            </button>
          </div>
        )}
        <div style={{ padding: "24px 32px" }}>{children}</div>
      </div>
      <SessionExpiryDialog
        open={warning}
        expiryAt={expiryAt}
        onContinue={dismiss}
        onLogout={() => logoutPortal({ expired: false })}
      />
    </>
  );
}
